import React from 'react';
import { SVGIconProps } from '../../domains/common';

const LogoIcon: React.FC<SVGIconProps> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="#1f2b58"
        d="M5.18 14.47h-.34A2.29 2.29 0 0 1 3.05 13L.15 5.43a2.27 2.27 0 0 1 1.64-3L12.41.05a2.27 2.27 0 0 1 2.42 1 2.24 2.24 0 0 1-.13 2.61L7 13.59a2.3 2.3 0 0 1-1.82.88Zm-1.28-9 1.64 4.3 4.36-5.6Z"
      />
      <path
        fill="#FFFFFF"
        d="M14.92 3.08 7.03 13.19 5.74 9.84l4.45-5.71 4.73-1.05z"
      />
    </svg>
  );
};

export default LogoIcon;
